var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"field"},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }